// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
.container-fluid {
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: #2c2f34;
  height: 100vh;
  display: flex;
  /* background-image: url('../../../assets/yantra.png'); */
  background-size: cover;
  background-position: center;
}
.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root{
  color:black !important;
}
.left-column {
  flex: 1 1;
  background-size: cover;
  height: 100vh;
}

.right-column {
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0;
  display: flex;
}

.login-card {
  background-color: #5756562e !important;
  backdrop-filter: blur(10px) !important;
  border: 2px solid white;
  margin: 0 auto;
  border-radius: 12px !important;
  width: 500px;
  max-width: 500px;
}

.login-card-header {
  background-color: white !important;
  color:black;
  font-weight: bold;
  margin-bottom: 25px;
  backdrop-filter: blur(10px) !important;
  font-size: 26px !important;
  animation: pulse 3s infinite;
  text-align: center;
}
.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
  color: #ec6e17 !important;

}
.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {
  color:black !important;
}

.outlinedInput-root-fieldset {
  border-color: black;
}

.outlinedInput-root-input {
  color: black;
}

.outlinedInput-root-focused-fieldset {
  border-color: #ec6e17;
}

.custom-placeholder::placeholder {
  color:  black;
  opacity: 1;
}

.icon-button-custom {
  color: green;
  background-color: black;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #3c2a2a00 inset !important;
  -webkit-text-fill-color: black !important;
  -webkit-transition: background-color 1000s ease-in-out 0s !important;
  transition: background-color 1000s ease-in-out 0s !important;
}

/* Responsive Styles */
@media (max-width: 767px) {
  /* Mobile View */
  .container-fluid {
    height: auto;
    min-height: 100vh;
    flex-direction: column;
  }

  .left-column {
    display: none;
  }

  .right-column {
    flex: unset;
    padding: 20px;
  }

  .login-card {
    width: 100%;
    max-width: 100%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  /* Tablet View */
  .container-fluid {
    flex-direction: row;
  }

  .left-column {
    flex: 1 1;
  }

  .right-column {
    flex: 1 1;
    padding: 20px;
  }

  .login-card {
    width: 80%;
    max-width: 80%;
  }
}

@media (min-width: 992px) {
  /* Desktop View */
  .container-fluid {
    flex-direction: row;
  }

  .left-column {
    flex: 1 1;
  }

  .right-column {
    flex: 1 1;
    padding: 20px;
  }

  .login-card {
    width: 500px;
    max-width: 500px;
  }
}
.button{
  text-align: center;
}

/* Toast Styles */
.toast-custom {
  background: #ffffff !important;
  border-radius: 10px !important;
  padding: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important;
  min-width: 300px;
  border: 1px solid #f0f0f0 !important;
}

.toast-custom--error {
  border-left: 4px solid #e53935 !important;
}

.toast-custom--success {
  border-left: 4px solid #2e7d32 !important;
}

.toast-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
}

.toast-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
}

.toast-icon--error {
  background: rgba(229, 57, 53, 0.12);
  color: #e53935;
  border: 1.5px solid #e53935;
}

.toast-icon--success {
  background: rgba(46, 125, 50, 0.12);
  color: #2e7d32;
  border: 1.5px solid #2e7d32;
}

.toast-title {
  color: #1a1a1a;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-bottom: 2px;
}

.toast-message {
  color: #666666;
  font-size: 12px;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/app/Pages/Login/login.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,yDAAyD;EACzD,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,yBAAyB;;AAE3B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,2DAA2D;EAC3D,yCAAyC;EACzC,oEAA4D;EAA5D,4DAA4D;AAC9D;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB;IACE,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAO;IACP,aAAa;EACf;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAO;IACP,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,qDAAqD;EACrD,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* General Styles */\n.container-fluid {\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background-color: #2c2f34;\n  height: 100vh;\n  display: flex;\n  /* background-image: url('../../../assets/yantra.png'); */\n  background-size: cover;\n  background-position: center;\n}\n.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root{\n  color:black !important;\n}\n.left-column {\n  flex: 1;\n  background-size: cover;\n  height: 100vh;\n}\n\n.right-column {\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  padding: 0;\n  display: flex;\n}\n\n.login-card {\n  background-color: #5756562e !important;\n  backdrop-filter: blur(10px) !important;\n  border: 2px solid white;\n  margin: 0 auto;\n  border-radius: 12px !important;\n  width: 500px;\n  max-width: 500px;\n}\n\n.login-card-header {\n  background-color: white !important;\n  color:black;\n  font-weight: bold;\n  margin-bottom: 25px;\n  backdrop-filter: blur(10px) !important;\n  font-size: 26px !important;\n  animation: pulse 3s infinite;\n  text-align: center;\n}\n.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {\n  color: #ec6e17 !important;\n\n}\n.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {\n  color:black !important;\n}\n\n.outlinedInput-root-fieldset {\n  border-color: black;\n}\n\n.outlinedInput-root-input {\n  color: black;\n}\n\n.outlinedInput-root-focused-fieldset {\n  border-color: #ec6e17;\n}\n\n.custom-placeholder::placeholder {\n  color:  black;\n  opacity: 1;\n}\n\n.icon-button-custom {\n  color: green;\n  background-color: black;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\ninput:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px #3c2a2a00 inset !important;\n  -webkit-text-fill-color: black !important;\n  transition: background-color 1000s ease-in-out 0s !important;\n}\n\n/* Responsive Styles */\n@media (max-width: 767px) {\n  /* Mobile View */\n  .container-fluid {\n    height: auto;\n    min-height: 100vh;\n    flex-direction: column;\n  }\n\n  .left-column {\n    display: none;\n  }\n\n  .right-column {\n    flex: unset;\n    padding: 20px;\n  }\n\n  .login-card {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  /* Tablet View */\n  .container-fluid {\n    flex-direction: row;\n  }\n\n  .left-column {\n    flex: 1;\n  }\n\n  .right-column {\n    flex: 1;\n    padding: 20px;\n  }\n\n  .login-card {\n    width: 80%;\n    max-width: 80%;\n  }\n}\n\n@media (min-width: 992px) {\n  /* Desktop View */\n  .container-fluid {\n    flex-direction: row;\n  }\n\n  .left-column {\n    flex: 1;\n  }\n\n  .right-column {\n    flex: 1;\n    padding: 20px;\n  }\n\n  .login-card {\n    width: 500px;\n    max-width: 500px;\n  }\n}\n.button{\n  text-align: center;\n}\n\n/* Toast Styles */\n.toast-custom {\n  background: #ffffff !important;\n  border-radius: 10px !important;\n  padding: 0 !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important;\n  min-width: 300px;\n  border: 1px solid #f0f0f0 !important;\n}\n\n.toast-custom--error {\n  border-left: 4px solid #e53935 !important;\n}\n\n.toast-custom--success {\n  border-left: 4px solid #2e7d32 !important;\n}\n\n.toast-body {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n}\n\n.toast-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.toast-icon--error {\n  background: rgba(229, 57, 53, 0.12);\n  color: #e53935;\n  border: 1.5px solid #e53935;\n}\n\n.toast-icon--success {\n  background: rgba(46, 125, 50, 0.12);\n  color: #2e7d32;\n  border: 1.5px solid #2e7d32;\n}\n\n.toast-title {\n  color: #1a1a1a;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  margin-bottom: 2px;\n}\n\n.toast-message {\n  color: #666666;\n  font-size: 12px;\n  line-height: 1.4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
